import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import AOS from "aos";
import "aos/dist/aos.css"; // Importation des styles d'AOS
import { Helmet } from "react-helmet";

const AboutUs = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000, // Durée de l'animation en ms
      once: true, // L'animation ne se joue qu'une fois
    });
  }, []);

  return (
    <div className="bg-gray-900 min-h-screen text-white">
      <Helmet>
        <title>À propos de nous | WebMinds</title>
        <meta
          name="description"
          content="Découvrez WebMinds, une agence spécialisée dans le développement d'applications mobiles et le design graphique. Apprenez à connaître notre équipe, nos valeurs, et notre mission de transformer vos idées en réalité."
        />
        <meta
          name="keywords"
          content="à propos, WebMinds, agence web, développement d'applications, design graphique, équipe, valeurs, mission"
        />
      </Helmet>

      <Navbar />
      <div className="container mx-auto px-4 py-12">
        <h1 className="text-4xl pt-16 md:text-5xl font-extrabold text-white mb-8 text-center">
          À Propos de Nous
        </h1>

        {/* Section Notre Mission */}
        <section id="mission" className="mb-12">
          <h2 className="text-3xl font-bold text-white mb-6 border-b-4 border-blue-500 pb-2">
            Notre Mission
          </h2>
          <p className="text-gray-300">
            Offrir des solutions adaptées aux besoins de nos clients en
            combinant innovation et expertise technique.
          </p>
        </section>

        {/* Section Notre Équipe */}
        <section id="team" className="mb-12">
          <h2 className="text-3xl font-bold text-white mb-6 border-b-4 border-green-500 pb-2">
            Notre Équipe
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* Membre 1 */}
            <div
              className="bg-gray-800 p-6 rounded-lg shadow-lg"
              data-aos="fade-up"
            >
              <div className="flex items-center">
                <img
                  src="/images/owen.jpeg"
                  alt="Owen Dayes"
                  className="w-24 h-24 object-cover rounded-full mr-4"
                />
                <div>
                  <h3 className="text-xl font-semibold text-white">
                    Owen Dayes
                  </h3>
                  <p className="text-gray-400">
                    Manager / Développeur des opérations
                  </p>
                  <p className="text-gray-300 mt-2">
                    Owen gère les opérations techniques et s'assure que nos
                    projets répondent aux standards les plus élevés.
                  </p>
                </div>
              </div>
            </div>
            {/* Membre 2 */}
            <div
              className="bg-gray-800 p-6 rounded-lg shadow-lg"
              data-aos="fade-up"
            >
              <div className="flex items-center">
                <img
                  src="/images/elisa.jpeg"
                  alt="Elisa Leblond"
                  className="w-24 h-24 object-cover rounded-full mr-4"
                />
                <div>
                  <h3 className="text-xl font-semibold text-white">
                    Elisa Leblond
                  </h3>
                  <p className="text-gray-400">Responsable Marketing / SEO</p>
                  <p className="text-gray-300 mt-2">
                    Elisa conçoit et met en œuvre nos stratégies marketing pour
                    maximiser notre visibilité en ligne.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Section Nos Valeurs */}
        <section id="values" className="mb-12">
          <h2 className="text-3xl font-bold text-white mb-6 border-b-4 border-red-500 pb-2">
            Nos Valeurs
          </h2>
          <ul className="space-y-4">
            <li
              className="bg-gray-800 p-6 rounded-lg shadow-lg"
              data-aos="fade-up"
            >
              <h3 className="text-xl font-semibold text-white mb-2">
                Innovation
              </h3>
              <p className="text-gray-300">
                Nous cherchons constamment à intégrer les dernières technologies
                pour offrir des solutions modernes.
              </p>
            </li>
            <li
              className="bg-gray-800 p-6 rounded-lg shadow-lg"
              data-aos="fade-up"
            >
              <h3 className="text-xl font-semibold text-white mb-2">
                Intégrité
              </h3>
              <p className="text-gray-300">
                Nous faisons preuve de transparence et d'honnêteté dans toutes
                nos interactions.
              </p>
            </li>
            <li
              className="bg-gray-800 p-6 rounded-lg shadow-lg"
              data-aos="fade-up"
            >
              <h3 className="text-xl font-semibold text-white mb-2">
                Excellence
              </h3>
              <p className="text-gray-300">
                Nous nous engageons à délivrer des résultats exceptionnels dans
                chaque projet.
              </p>
            </li>
          </ul>
        </section>

        {/* Section Contact */}
        <div className="text-center mt-16">
          <h3 className="text-2xl font-semibold text-white mb-4">
            Vous souhaitez en savoir plus ?
          </h3>
          <p className="text-lg text-gray-300 mb-6">
            Contactez-nous pour toute question ou pour discuter de votre projet.
          </p>
          <a
            href="/contact"
            className="inline-block px-8 py-4 bg-blue-500 text-white text-lg font-semibold rounded-md hover:bg-blue-400 transition-colors duration-300"
          >
            Contactez-nous
          </a>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AboutUs;
